module.exports = __webpack_public_path__ + "static/media/akilli_sistemler.f780d657.jpg";